/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var IncomeTypeEnum;

(function (IncomeTypeEnum) {
  IncomeTypeEnum["RATE"] = "rate";
  IncomeTypeEnum["TOTAL"] = "total";
})(IncomeTypeEnum || (IncomeTypeEnum = {}));